/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material/styles';

export const sidebarAppBarContentSX: SxProps<Theme> = {
	color: '#000000',
	lineHeight: (theme) => theme.spacing(6),
};
